import { render, staticRenderFns } from "./findPwd.vue?vue&type=template&id=fef98346"
import script from "./findPwd.vue?vue&type=script&lang=js"
export * from "./findPwd.vue?vue&type=script&lang=js"
import style0 from "./findPwd.vue?vue&type=style&index=0&id=fef98346&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports